angular.module( 'acme.view.application.passes.create.modals.remove', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.passes.create.modals.remove.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var passesCreateModalsRemove = {
        name: 'application.passes.create.modals.remove',
        url: '/passes/create/modals/remove',
        views: {
          "main": {
            controller: 'PassesCreateModalsRemoveController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/passes/create/modals/remove/remove.tpl.html'
          }
        },
        data: {
          pageTitle: '    ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(passesCreateModalsRemove);
});
